import React, { useEffect, useState } from "react";

const ReportsList = ({ onEdit }) => {
    const [reports, setReports] = useState([]);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    useEffect(() => {
        fetch(`${apiUrl}/reports`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch reports");
                }
                return response.json();
            })
            .then((data) => setReports(data))
            .catch((error) => {
                console.error("Error fetching reports:", error);
                setError("Failed to load reports. Please try again.");
            });
    }, []);

    if (error) {
        return <p className="text-danger">{error}</p>;
    }

    return (
        <div className="table-responsive">
            <table className="table table-striped">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Url</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {reports.map((report) => (
                    <tr key={report.id}>
                        <td>{report.university.name}</td>
                        <td>{report.report_url}</td>
                        <td>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => onEdit(report)}
                            >
                                Edit
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReportsList;